import { Button } from '@/clients/shared-components//ui/button';
import { Text } from '@/clients/shared-components/Typography';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/clients/shared-components/ui/dropdown-menu';
import { useAuthedUserContext } from '@/clients/shared-hooks/use-authed-user';
import { fetchJson } from '@/clients/util/xhr';
import { isLanguageCode } from '@/ifaces/language';
import { useMutation } from '@tanstack/react-query';
import { ChevronDownIcon, Languages } from 'lucide-react';
import { useLanguages } from '../hooks/use-languages';

export const LanguageSwitcher = () => {
  const languageCode = useAuthedUserContext().profile.language_code;
  const { languages } = useLanguages();

  const { mutateAsync: updateLanguage } = useMutation({
    mutationFn: (languageCode: string) =>
      fetchJson('api/profile', {
        profile: { language_code: languageCode },
      }),
  });

  const handleLanguageChange = async (languageCode: string) => {
    if (!isLanguageCode(languageCode)) return;
    await updateLanguage(languageCode);
    window.location.reload();
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="secondary"
          size="sm"
          className="bg-white shadow-none hover:bg-accent/90 p-0 px-2"
        >
          <Languages />
          <Text s bold style={{ textTransform: 'uppercase' }}>
            {languageCode}
          </Text>
          <ChevronDownIcon className="ml-auto size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {languages?.map((language) => (
          <DropdownMenuItem
            className="cursor-pointer py-2.5"
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
          >
            {language.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
